export const MAP_SPEED_OVERRIDE_DELETE_OPEN_MODAL = "MAP_SPEED_OVERRIDE_DELETE_OPEN_MODAL";
export const MAP_SPEED_OVERRIDE_DELETE_SPEED_OVERRIDE = "MAP_SPEED_OVERRIDE_DELETE_SPEED_OVERRIDE";
export const MAP_SPEED_OVERRIDE_DELETE_SPEED_OVERRIDE_RESPONSE = "MAP_SPEED_OVERRIDE_DELETE_SPEED_OVERRIDE_RESPONSE";